import React, { useEffect, useState } from "react";
import { Box, Typography, Grid, Tabs, Tab, Button, TextField, FormControlLabel, Checkbox } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { getListAPI } from '../../../components/pmorder/PmorderAPI';
import { setCompleteTaskButtonEnabled, setReferbackTaskButtonEnabled } from "store/slice/AppSlice";
import ProductInfo from "./ProductInfo";
import CommentMgmt from "./comment/CommentMgmt";
import ImageGalleryHolder from "core/components/image-gallery/ImageGalaryHolder";
import { setProductSelectImageModal, setProductassetDashboardProductassetList, setAssetcommentsList, updateProductObj } from 'store/slice/PharmaSlice';
import SelectImageActionModal from "components/product/action/selectImage/SelectImageActionModal";
import { getProductassetInfoByProductidAPI } from "components/productasset/ProductassetAPI";
import { setHideTaskActionBar } from "store/slice/AppSlice";
import { initRefreshTaskList } from "store/slice/AppSlice";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { setSelectedImage, setSelectedAssetIdList } from "store/slice/ImageGallerySlice";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { submitDesignQaApprovalAPI } from "api/OmsOrdermgmtWebServices";
import { setProductassetViewModal } from "store/slice/PharmaSlice";
import { getAssetcommentsInfoByProductidAPI } from 'components/assetcomments/AssetcommentsAPI';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { updateProductInfo } from "components/product/ProductAPI";
import { convertDateInFormat_yyyyMMdd } from "core/js/FormUtils";
import FieldView2 from "core/components/layout/FieldView2";

const steps = [
  "View Asset List",
  "Upload Asset & Customer Approval",
  "Submitted for Approval"
];

export default function TaskSpaceDesigner() {
  const dispatch = useDispatch();
  const [confirmed, setConfirmed] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [apiError, setApiError] = useState(""); // <-- Add this line
  const { productObj } = useSelector((state) => state.pharmaslice.productDashboard);
  
  // Add state for design confirmation checkbox (for task 51)
  const [designConfirmed, setDesignConfirmed] = useState(false);
  
  const [customerApprovalDate, setCustomerApprovalDate] = useState(convertDateInFormat_yyyyMMdd(productObj.designapprovaldate));
  const [tabIndex, setTabIndex] = useState(0);
  const { selectedTaskObj, taskCompleted } = useSelector((state) => state.appslice.wkflow);
  const { productassetList } = useSelector((state) => state.pharmaslice.productassetDashboard);
  const { selectedImagePath, selectedImage,selectedImageId } = useSelector((state) => state.imagegalleryslice);

  
  useEffect(() => {
    dispatch(setSelectedImage({ name: '', path: '' }));
    dispatch(setSelectedAssetIdList(''));
    dispatch(setHideTaskActionBar(false));
    dispatch(setReferbackTaskButtonEnabled(true));
  }, []);
  useEffect(() => {
    if (productassetList && productassetList.length === 0) {
      setActiveStep(1);
    }
    else {
      {
        getAssetcommentsInfoByProductidAPI(productObj.id, () => { },
          (response) => {
            dispatch(setAssetcommentsList(response))
          });
        setActiveStep(0);
      }
    }
  }, [productassetList]);

  useEffect(()=>{
    if (productObj){
      setCustomerApprovalDate(convertDateInFormat_yyyyMMdd(productObj.designapprovaldate));
    }
  },[productObj])


  useEffect(()=>{
    if (selectedTaskObj.taskid===48){
      if (productObj.designapprovaldate && confirmed && productObj.assetid!=0) {
        dispatch(setCompleteTaskButtonEnabled(true))
      } else {
      dispatch(setCompleteTaskButtonEnabled(false))
      }
      return;
    }
    
    else if (selectedTaskObj.taskid===51){
      let canCompleteTask = false;
      
      // For task 51, check if asset exists and design is confirmed
      if (productObj.assetpath && designConfirmed) {
        // If it's a form that requires set name and color, check those too
        if (productObj.formname === "Tablet" || productObj.formname === "Capsule" || productObj.formname === "Capsul" || productObj.formname === "Sachet") {
          canCompleteTask = productObj.setname && productObj.liquidcolor;
        } else {
          // For other forms, check if color exists
          canCompleteTask = productObj.liquidcolor || true; // Allow completion even without color for some forms
        }
      }
      
      dispatch(setCompleteTaskButtonEnabled(canCompleteTask));
    }
  },[confirmed, designConfirmed, productObj])

  useEffect(() => {
      if (productObj && selectedImageId!==-1) {
        updateProductInfo(productObj.id,
        {
          assetid: selectedImageId,
          assetname: selectedImage,
          assetpath: selectedImagePath
        },
          (response) => {
            dispatch(updateProductObj(response));
          },
          (error) => {
            console.error("Failed to attach asset to product:", error);
          }
      )}
    },[selectedImageId]);

  const showAsset = (imageObj) => {
    dispatch(setSelectedImage({ 'name': productObj.assetname, 'path': productObj.assetpath }));
    dispatch(setProductassetViewModal(true));

  }
  const showQAasset = () => {
    dispatch(setSelectedImage({ 'name': productObj.qaassetname, 'path': productObj.qaassetpath }));
    dispatch(setProductassetViewModal(true));

  }
  
  const updateCustomerApprovalDate = (newDate) =>{
    console.log("newDate==>",newDate)
    updateProductInfo(productObj.id, 
      { designapprovaldate:newDate!==''? newDate : null}
      ,(response) => {
        dispatch(updateProductObj(response));
      }
      ,(error) => {
        console.error("Error updating customer approval date:", error);
        setApiError(error);
      });
  }

  const handleDateChange = (newDate) => {
   updateCustomerApprovalDate(newDate);
  }

  // Handler for design confirmation checkbox
  const handleDesignConfirmationChange = (event) => {
    setDesignConfirmed(event.target.checked);
  };

  return (
    <Grid container sx={{ width: '100%', }}>
      <Grid item lg={4} md={4} sm={12} xs={12}>
        <Box sx={{ borderRadius: 2, minHeight: '75vh', p: 0 }}>
          <Tabs
            value={tabIndex}
            onChange={(_, v) => setTabIndex(v)}
            variant="fullWidth"
            sx={{ borderBottom: 1, borderColor: 'divider' }}
          >
            <Tab label="Product Info" />
            <Tab label="Comments" />
          </Tabs>
          <Box sx={{}}>
            {tabIndex === 0 && (
              <ProductInfo maxHeight="70vh" />
            )}
            {tabIndex === 1 && (
              <Box sx={{ p: 2, minHeight: '70vh' }}>
                <Box sx={{ backgroundColor: 'white', borderRadius: 2, p: 1 }}>
                  <CommentMgmt maxHeight="60vh" status={1} />
                </Box>
              </Box>
            )}
          </Box>
        </Box>
      </Grid>
      <Grid item lg={4} md={8} sm={12} xs={12}>
        <Grid container direction="row" sx={{ width: '100%' }}>
          <Grid item lg={12} sx={{ p: 1 }}>
            <Grid container direction="column" sx={{ width: '100%', }}>
              <Grid item lg={12} sx={{}}>
                <Box sx={{ p: 1, backgroundColor: 'white', borderRadius: 2 }}>
                  <Grid container justifyContent="space-between" sx={{}}>
                                    <Grid item lg={6}>
                                      <Typography variant="h6" sx={{ color: 'primary.darker', }}>Design Under Review </Typography>
                                    </Grid>

                                    {!taskCompleted && productObj.assetpath && 
                                      <Grid container justifyContent="flex-end" lg={6}>
                                        <Button variant="text" size="small" onClick={() => dispatch(setProductSelectImageModal(true))}>
                                          Change
                                        </Button>
                                      </Grid>
                                    }
                  </Grid>
                  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", cursor: "pointer", mt: 1 }}>
                    {!productObj.assetpath ? (
                      <CloudUploadIcon
                        sx={{ fontSize: 80, color: "#bdbdbd", mb: 2 }}
                        onClick={() => dispatch(setProductSelectImageModal(true))}
                        titleAccess="Upload Asset"
                      />
                    ) : (
                      <img
                        onClick={() => { showAsset() }}
                        src={productObj.assetpath}
                        alt="Product Asset"
                        style={{ borderRadius: 8, marginBottom: 16 }}
                        width="350px"
                        height="350vh"
                      />
                    )}
                  </Box>
                </Box>
                
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        
      </Grid>
      {selectedTaskObj.taskid===48?
        <Grid item lg={4} md={8} sm={12} xs={12}>
            <Box
                          sx={{
                            mt:1,
                            flex: 1,
                            background: "white",
                            borderRadius: 2,
                            p: 3,
                            //boxShadow: 1,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "left",
                            justifyContent: "center",
                          // minHeight: 200,
                            gap: 2
                          }}
                        >
                          <TextField
                            label="Customer Approval Date"
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            sx={{ minWidth: 220 }}
                            value={customerApprovalDate || ""}
                            onChange={e => handleDateChange(e.target.value)}
                            disabled={taskCompleted}
                            inputProps={{
                              max: new Date().toISOString().split("T")[0] // restrict to today or earlier
                            }}
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={confirmed}
                                onChange={e => setConfirmed(e.target.checked)}
                                color="primary"
                                disabled={taskCompleted}
                              />
                            }
                            label="I confirm that Customer has approved this asset on above mentioned date."
                          />
                        </Box>

            
          </Grid>:
          <>
          <Grid item lg={4} md={8} sm={12} xs={12}>
          {/* Set Name and Color Box */}
            <Box sx={{
              mt: 1,
              background: "white",
              borderRadius: 2,
              p: 2,
            }}>
              <Grid item>
                <FieldView2 label="Set Name" value={productObj.setname || "-"} />
              </Grid>
              
              <Grid item>
                <FieldView2 label="Color" value={productObj.liquidcolor || "-"} />
              </Grid>
              
              {/* Confirmation Checkbox - Only for task 51 */}
              {selectedTaskObj.taskid === 51 && (
                <Box sx={{ mt: 2, p: 2, backgroundColor: '#f5f5f5', borderRadius: 2, border: '1px solid #e0e0e0' }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={designConfirmed}
                        onChange={handleDesignConfirmationChange}
                        color="primary"
                        disabled={taskCompleted}
                      />
                    }
                    label={
                      <Typography variant="body2" sx={{ fontSize: '0.875rem', lineHeight: 1.4 }}>
                        I confirm that Uploaded Design meets color and set requirement of the product and Ready for QA Check
                      </Typography>
                    }
                    sx={{ alignItems: 'flex-start', mt: 0.5 }}
                  />
                </Box>
              )}
              
            </Box>
            </Grid>
          </>
      }
      <SelectImageActionModal />
    </Grid>
  );
}